import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=681dfed2"
import script from "./Documentos.vue?vue&type=script&lang=js"
export * from "./Documentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports